module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/ticket-06395f15b94c30a1ce8fe05b92a47534.gif";